<template>
    <v-container grid-list-sm fluid>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Gantt</h1>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm3 md2>
                <empresa-select v-model="d.empresa_id" @input="getRecursos"></empresa-select>
            </v-flex>
            <v-flex xs12 sm3 md3>
                <v-select label="Recurso" v-model="d.recurso_id" :items="recursos" clearable item-text="H1_DESCRI" item-value="H1_CODIGO"></v-select>
            </v-flex>
            <v-flex xs12 sm3 md2>
                <v-menu
                        lazy
                        :close-on-content-click="false"
                        v-model="menuDesde"
                        transition="scale-transition"
                        offset-y
                        :nudge-left="40"
                        full-width
                        min-width="290px"
                >
                    <v-text-field
                            name="desde"
                            slot="activator" label="Desde" v-model="d.desde" prepend-icon="event" readonly></v-text-field>
                    <v-date-picker v-model="d.desde" first-day-of-week="1" locale="es-sp" scrollable></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md2>
                <v-menu
                        lazy
                        :close-on-content-click="false"
                        v-model="menuHasta"
                        transition="scale-transition"
                        offset-y
                        :nudge-left="40"
                        full-width
                        min-width="290px"
                >
                    <v-text-field
                            name="hasta"
                            slot="activator" label="Hasta" v-model="d.hasta" prepend-icon="event" readonly></v-text-field>
                    <v-date-picker v-model="d.hasta" first-day-of-week="1" locale="es-sp" scrollable></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex>
                <v-btn color="primary" @click.native="datos" :loading="loading">mostrar</v-btn>
            </v-flex>
        </v-layout>
        <v-layout column>
            <v-flex>
                <div class="fixed_header">
                    <table class="v-datatable v-table theme--light tabla-compacta">

                        <thead class="text-xs-center">
                            <th>Orden de Prod</th>
                            <th>Producto</th>
                            <th>Cliente</th>
                            <th>Pedido</th>
                            <th>Presupuesto</th>
                            <th>Cantidad OP</th>
                            <th>Reportado</th>
                            <th>F. Prev. Ini.</th>
                            <th>F. Prev. Fin</th>
                            <th>F. Ini. Prod.</th>
                            <th>F. Fin Prod.</th>
                            <th v-for="d in rangeArray" class="text-xs-center pa-0">
                                {{ d.format('MMM')}}
                                <br>
                                {{ d.format('DD') }}
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="i in items">
                                <td class="text-xs-center">{{ i.op }}</td>
                                <td class="text-xs-center">
                                    <v-tooltip top>
                                        <span slot="activator">{{ i.productoId }}</span>
                                        <span>{{ i.producto }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-xs-center">
                                    <v-tooltip top>
                                        <span slot="activator">{{ i.cliente }}</span>
                                        <span>{{ i.clienteId }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-xs-center" @click="pedidoMostrar(i.pedido)">
                                    <a href="#">{{ i.pedido }}</a>
                                </td>
                                <td class="text-xs-center">
                                    <router-link target="_blank" exact :to="'/presupuesto/' +  i.presupuesto">{{ i.presupuesto }}</router-link>
                                </td>
                                <td class="text-xs-right">{{ i.cant }}</td>
                                <td class="text-xs-right">{{ i.reportado }}</td>
                                <td class="text-xs-center">{{ i.start }}</td>
                                <td class="text-xs-center">{{ i.end }}</td>
                                <td class="text-xs-center">{{ (i.prodStart)? i.prodStart : '' }}</td>
                                <td class="text-xs-center">{{ (i.prodEnd)?i.prodEnd : '' }}</td>
                                <template v-for="d in rangeArray">
                                    <td :style="{'background-color': (contiene(d,i.start,i.end))? i.color: ''}"
                                        class="text-xs-center"
                                        :class="{producido: contiene(d,i.prodStart,i.prodEnd) && i.prodStart && i.prodEnd}"
                                        @mouseover="(contiene(d,i.start,i.end))?show($event,i): showMenu = false"
                                    >

                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
                        <v-card dark class="white--text" :color="itemData.color">
                            <v-card-text>
                                <b>Estado:</b> {{ itemData.estado }}
                                <br>
                                <b>Cantidad:</b> {{ itemData.cant }}
                                <br>
                                <b>Reportado:</b> {{ itemData.reportado }}
                            </v-card-text>
                        </v-card>
                    </v-menu>
                </div>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 sm4>
                <div class="fixed_header">
                    <table class="v-datatable v-table theme--light tabla-compacta">
                        <caption>TOTALES POR PRODUCTO</caption>
                        <thead class="text-xs-center">
                            <th>Producto</th>
                            <th>Total</th>
                        </thead>
                        <tbody>
                            <tr v-for="t in totales">
                                <td class="text-left">{{ t.C2_PRODUTO }}</td>
                                <td class="text-xs-right">{{ t.TOTAL | decimales }} {{ t.C2_UM }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </v-flex>
        </v-layout>
        <!--/////////////////////////////DIALOG DE PEDIDO DE VENTA///////////////////////////////////////////////////////////-->
        <pedido-venta-dialog v-model="pedidoVentaDialog" :emp="d.empresa_id" :pedido="pedido"></pedido-venta-dialog>
    </v-container>
</template>

<script>
    import mixinPcp from '../../mixins/pcp';
    import empresaSelect from '../../components/EmpresaSelect';
    import pedidoVentaDialog from '../../components/PedidoVentaDialog';
    import Moment from 'moment';
    import {extendMoment} from 'moment-range';
    import decimales from '../../filters/decimales'

    const moment = extendMoment(Moment);

    export default {
        name: "gantt",
        components: {empresaSelect, pedidoVentaDialog},
        mixins: [mixinPcp],
        filters: {decimales},
        data() {
            return {
                loading: false,
                items: [],
                totales: [],
                fechas: [],
                headers: [],
                d: {
                    desde: moment().format('YYYY-MM-DD'),
                    hasta: moment().add(1, 'w').format('YYYY-MM-DD'),
                    empresa_id: ''
                },
                menuDesde: false,
                menuHasta: false,
                range: {},
                rangeArray: [],
                pedidoVentaDialog: false,
                pedido: '',
                showMenu: false,
                x: 0,
                y: 0,
                itemData: {},
                recursos: []
            }
        },
        methods: {
            datos() {
                let desde = moment(this.d.desde);
                let hasta = moment(this.d.hasta);
                this.range = moment.range(desde, hasta);
                this.rangeArray = Array.from(this.range.by('day'));
                this.loading = true;
                this.$http.post('pcp/gantt/datos', this.d)
                    .then(r => {
                        this.items = r.data.datos;
                        this.totales = r.data.totales;
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
            },
            contiene(fecha, start, end) {
                let range = moment.range(start, end);
                return range.contains(fecha);
            },
            pedidoMostrar(pedido) {
                this.pedido = pedido;
                this.pedidoVentaDialog = true;
            },
            show(e, i) {
                e.preventDefault();
                this.showMenu = false;
                this.x = e.clientX;
                this.y = e.clientY;
                this.itemData = i;
                this.$nextTick(() => {
                    this.showMenu = true
                })
            },
            getRecursos() {
                this.pcpRecursos({emp: this.d.empresa_id}, r => {
                    this.recursos = r;
                }, err => console.log(err));
            }
        }
    }
</script>

<style scoped>
    .fixed_header {
        overflow: auto;
        height: 300px;
    }

    .fixed_header thead th {
        position: sticky !important;
        top: 0 !important;
        background: #ffffff;
        z-index: 2;
    }

    td.producido {
        position: relative;
    }

    .producido:after {
        content: "";
        display: block;
        width: 100%;
        height: 6px;
        background-color: black;
        position: absolute;
        top: 35%;
        left: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/pcp/gantt.vue